const formatCurrency = (value) => {
    if (!value) {
        value = 0;
    }

    return parseFloat(value).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
};

export default {
    formatCurrency
};